import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { IEmailConfig } from "../interfaces/IEmailConfig";
import { historys } from "../..";
import Swal, { SweetAlertResult } from "sweetalert2";
import { AnyAsyncThunk } from "@reduxjs/toolkit/dist/matchers";
import { IMachine, IMachineConfig } from "../interfaces/IMachineConfig";
export default class machineConfigStore {
  emailConfig: IEmailConfig | null = null;
  editMode = false;
  loading = false;
  submitting = false;
  selectMachine: IMachineConfig | undefined = undefined;
  checkRegistered = false;
  updateSerial = false;
  constructor() {
    makeAutoObservable(this);
  }
  getMachineBySerialNo = async (id: IMachine) => {
    try {
        const result = await agent.MachineConfig.getMachineBySerialNo(id).catch(async s =>{
          const alertResult: SweetAlertResult = await Swal.fire({
            icon: "warning",
            title: "Warning",
            text: s.response.data,
            showLoaderOnConfirm: true,
            timer: 2500,
          });
          this.loading = false;
          throw Error();
          
        });
        runInAction(() => {
            this.selectMachine = result;
            this.loading = false;
        })
        return result;
    } catch (error) {
        runInAction(() => {
          this.loading = false;
        })
    }
  }
  UpdateSerial = async (e:IEmailConfig) => {
    this.loading = true;
    try {
      const result = await agent.MachineConfig.UpdateSerial(e).catch(async s =>{
        const alertResult: SweetAlertResult = await Swal.fire({
          icon: "warning",
          title: "Warning",
          text: s.response.data,
          showLoaderOnConfirm: true,
        });
        throw Error();
      });
      runInAction(() => {
        if (result) {
          this.updateSerial = true;
          this.loading = false;
        }
      });
      return true;
    } catch (error) {
      runInAction(() => (this.loading = false));
      return false;
    }
  };
}
